import React, { useState } from 'react'
import Header from './Header'
import Family from '../Assets/Assests/family-drawing.png'
import Brain from '../Assets/Assests/Brain-image.png'
import Footer from './Footer'
import { useNavigate } from 'react-router-dom'

const Membership = () => {
  const [showMore, setShowMore] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const navigate = useNavigate()

  const handleToggle = () => {
    setShowMore((prev) => !prev)
  }

  const handlePayment = () => {
    navigate('/payment-form')
  }

  const handleEnquiry = () => {
    navigate('/enquiry-form')
  }

  const planCardStyle = {
    backgroundColor: '#e6f3ff',
    borderRadius: '15px',
    padding: '20px',
    marginBottom: '30px',
    border: 'none',
    boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
    position: 'relative',
    overflow: 'hidden',
  }

  const titleStyle = {
    color: '#2D5272',
    fontSize: 'clamp(1.5rem, 4vw, 2rem)',
    fontWeight: '600',
    marginBottom: '8px',
    lineHeight: '1.3',
    fontFamily: 'Inter',
  }

  const subtitleStyle = {
    color: '#4a6fa5',
    marginBottom: '20px',
    lineHeight: '1.4',
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: 'clamp(1rem, 3vw, 1.5rem)',
  }

  const priceStyle = {
    color: '#2c5282',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    fontWeight: '600',
    marginBottom: '20px',
  }

  const featureListStyle = {
    listStyle: 'none',
    padding: '0',
    margin: '0',
  }

  const featureStyle = {
    padding: '0',
    margin: '0',
  }

  const featureItemStyle = {
    color: '#4a5568',
    fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
    marginBottom: '8px',
    paddingLeft: '15px',
    position: 'relative',
    lineHeight: '1.4',
  }

  const buttonStyle = {
    backgroundColor: '#4a6fa5',
    color: 'white',
    border: 'none',
    borderRadius: '25px',
    padding: '10px 25px',
    fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    transition: 'all 0.3s ease',
    width: '100%',
    maxWidth: '200px',
  }

  const illustrationStyle = {
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: '0.3',
    width: '120px',
    height: '120px',
  }

  const learnMoreStyle = {
    fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
    color: '#2D5272',
    cursor: 'pointer',
    marginTop: '10px',
    display: 'inline-block',
  }

  const offerBoxStyle = {
    background: '#2E5272CF',
    color: 'white',
    padding: '15px',
    width: '100%',
    borderRadius: '5px',
    marginTop: '20px',
    lineHeight: '1.6',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
  }

  return (
    <>
      <Header />

      <div className='min-h-screen'>
        <header
          id='home'
          className='container-fluid text-white d-flex align-items-center justify-content-center'
          style={{
            backgroundColor: '#2D5272',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '350px',
            position: 'relative',
            top: '70px',
          }}
        >
          <div
            className='text-center px-3 py-3'
            style={{
              zIndex: 2,
              borderRadius: '10px',
            }}
          >
            <h1
              style={{
                fontFamily: 'Inter',
                fontWeight: '600',
                fontSize: '50px',
                color: '#fff',
              }}
            >
              Tesla Bird Membership
            </h1>
          </div>
        </header>
        <div className='container' style={{ marginTop: '100px' }}>
          {/* Header */}
          <div className='row mb-2'>
            <div className='col-12'>
              <h1
                style={{
                  color: '#2c5282',
                  fontSize: '2.5rem',
                  fontWeight: '600',
                  marginBottom: '0',
                }}
              >
                Choose a plan
              </h1>
            </div>
          </div>

          <div className='row'>
            <div className='col-12'>
              <div className='card' style={planCardStyle}>
                {/* <div className='row align-items-center'>
                  <div className='col-lg-12 col-md-7 col-12'>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div style={{ flex: '1 1 70%' }}>
                        <h2 style={titleStyle}>
                          Tesla Bird Mental Wellness Card Kit
                        </h2>
                        <p style={subtitleStyle}>
                          Price: ₹2499/- | Empower Your Mind, Daily
                        </p>
                        <p style={priceStyle}>
                          In today’s fast-paced world, mental wellness is
                          paramount. The Tesla Bird Mental Wellness Card Kit is
                          your daily companion, designed to enhance emotional
                          resilience, focus, and self-care.
                        </p>
                        <p style={priceStyle}>
                          Whether you’re a student, professional, parent, or
                          someone seeking balance, this kit offers practical
                          tools aligned with global mental health guidelines.
                        </p>
                      </div>

                      <div style={{ flex: '0 0 auto' }}>
                        <button
                          style={buttonStyle}
                          onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#3a5a8a'
                            e.currentTarget.style.transform = 'translateY(-2px)'
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = '#4a6fa5'
                            e.currentTarget.style.transform = 'translateY(0)'
                          }}
                          onClick={handlePayment}
                        >
                          Pay Now
                        </button>
                      </div>
                    </div>

                    <div style={{ textAlign: 'center' }}>
                      {!showMore && (
                        <span style={learnMoreStyle} onClick={handleToggle}>
                          Learn More ▼
                        </span>
                      )}
                    </div>
                    
                    {showMore && (
                      <div style={{ marginTop: '15px' }}>
                        <h2
                          style={{
                            color: '#2c4f6e',
                            fontSize: '20px',
                            fontWeight: '600',
                            marginTop: '25px',
                            marginBottom: '15px',
                          }}
                        >
                          What's Inside the Kit:
                        </h2>

                        <div
                          style={{
                            color: '#2c4f6e',
                            fontSize: '15px',
                            lineHeight: '1.5',
                          }}
                        >
                          <p style={{ marginBottom: '5px' }}>
                            <strong>
                              1. 100 Mental Wellness Overview Cards:
                            </strong>
                          </p>
                          <p
                            style={{
                              marginLeft: '15px',
                              marginBottom: '15px',
                            }}
                          >
                            Gain clear insights into over 100 mental health
                            conditions, including anxiety, depression, ADHD, and
                            more. Based on WHO Mental Health Framework and
                            NIMHANS India guidelines.
                          </p>

                          <p style={{ marginBottom: '5px' }}>
                            <strong>2. Brain Teasers Cards:</strong>
                          </p>
                          <p
                            style={{
                              marginLeft: '15px',
                              marginBottom: '15px',
                            }}
                          >
                            Engage with puzzles and logic tasks to boost memory
                            and cognitive flexibility.
                          </p>

                          <p style={{ marginBottom: '5px' }}>
                            <strong>3. Meditation & Breathing Cards:</strong>
                          </p>
                          <p
                            style={{
                              marginLeft: '15px',
                              marginBottom: '15px',
                            }}
                          >
                            Access guided techniques like box breathing and
                            grounding meditations for instant stress relief.
                          </p>

                          <p style={{ marginBottom: '5px' }}>
                            <strong>4. Mind Cognitive Cards:</strong>
                          </p>
                          <p
                            style={{
                              marginLeft: '15px',
                              marginBottom: '15px',
                            }}
                          >
                            Develop emotional intelligence and resilience
                            through daily prompts.
                          </p>

                          <p style={{ marginBottom: '5px' }}>
                            <strong>
                              5. Mental Wellness Planner & Journals:
                            </strong>
                          </p>
                          <p
                            style={{
                              marginLeft: '15px',
                              marginBottom: '15px',
                            }}
                          >
                            Track moods, habits, and reflections with structured
                            weekly planners.
                          </p>

                          <p style={{ marginBottom: '5px' }}>
                            <strong>6. Gratification Cards:</strong>
                          </p>
                          <p
                            style={{
                              marginLeft: '15px',
                              marginBottom: '15px',
                            }}
                          >
                            Foster joy and connection with daily gratitude
                            exercises.
                          </p>
                        </div>

                        <div className='row mt-4'>
                          <div className='col-md-6'>
                            <h2
                              style={{
                                color: '#2c4f6e',
                                fontSize: '20px',
                                fontWeight: '600',
                                marginBottom: '15px',
                              }}
                            >
                              Who This is For:
                            </h2>
                            <ul
                              style={{
                                color: '#2c4f6e',
                                fontSize: '15px',
                                paddingLeft: '20px',
                              }}
                            >
                              <li style={{ marginBottom: '8px' }}>
                                Students managing academic stress
                              </li>
                              <li style={{ marginBottom: '8px' }}>
                                Professionals facing workplace challenges
                              </li>
                              <li style={{ marginBottom: '8px' }}>
                                Mental health facilitators and therapists
                              </li>
                              <li style={{ marginBottom: '8px' }}>
                                Families aiming for emotional well-being
                              </li>
                              <li style={{ marginBottom: '8px' }}>
                                Anyone seeking daily mental clarity and balance
                              </li>
                            </ul>
                          </div>

                          <div className='col-md-6'>
                            <h2
                              style={{
                                color: '#2c4f6e',
                                fontSize: '20px',
                                fontWeight: '600',
                                marginBottom: '15px',
                              }}
                            >
                              Why It Works:
                            </h2>
                            <ul
                              style={{
                                color: '#2c4f6e',
                                fontSize: '15px',
                                paddingLeft: '20px',
                              }}
                            >
                              <li style={{ marginBottom: '8px' }}>
                                Rooted in cognitive science and behavioral
                                psychology
                              </li>
                              <li style={{ marginBottom: '8px' }}>
                                Aligns with NIMHANS and WHO mental well-being
                                practices
                              </li>
                              <li style={{ marginBottom: '8px' }}>
                                Portable, non-digital, and user-friendly
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className='mt-4'>
                          <h2
                            style={{
                              color: '#2c4f6e',
                              fontSize: '20px',
                              fontWeight: '600',
                              display: 'flex',
                              alignItems: 'center',
                              marginBottom: '15px',
                            }}
                          >
                            <span style={{ marginRight: '8px' }}>📞</span>{' '}
                            Mental Health Support Resources:
                          </h2>
                          <p
                            style={{
                              color: '#2c4f6e',
                              fontSize: '15px',
                              marginBottom: '10px',
                            }}
                          >
                            If you or someone you know needs professional mental
                            health support:
                          </p>
                          <p
                            style={{
                              color: '#2c4f6e',
                              fontSize: '15px',
                              marginBottom: '5px',
                              fontWeight: '500',
                            }}
                          >
                            TELE-MANAS India Toll-Free 24/7 Helpline: 14416 or
                            1-800-891-4416
                          </p>
                          <p
                            style={{
                              color: '#2c4f6e',
                              fontSize: '15px',
                              marginBottom: '20px',
                            }}
                          >
                            Provides free, round-the-clock mental health support
                            in 20+ languages across India.
                          </p>
                        </div>

                        <div className='mt-3'>
                          <h2
                            style={{
                              color: '#2c4f6e',
                              fontSize: '20px',
                              fontWeight: '600',
                              marginBottom: '15px',
                            }}
                          >
                            Enhance Your Life With:
                          </h2>
                          <ul
                            style={{
                              color: '#2c4f6e',
                              fontSize: '15px',
                              paddingLeft: '20px',
                            }}
                          >
                            <li style={{ marginBottom: '8px' }}>
                              Improved focus
                            </li>
                            <li style={{ marginBottom: '8px' }}>
                              Emotional balance
                            </li>
                            <li style={{ marginBottom: '8px' }}>
                              Daily self-care routines
                            </li>
                            <li style={{ marginBottom: '8px' }}>
                              Increased self-awareness
                            </li>
                            <li style={{ marginBottom: '8px' }}>
                              Cultivated Gratitude
                            </li>
                          </ul>
                         
                        </div>
                        <div
                          className='mt-4'
                          style={offerBoxStyle}
                          // style={{
                          //   background: '#2E5272CF',
                          //   color: 'white',
                          //   fontSize: '15px',
                          //   lineHeight: '1.6',
                          //   fontFamily: 'Inter',
                          // }}
                        >
                          <strong>Launch Offer: ₹2200/- Only</strong>
                          <br />
                          Eco-friendly packaging, ideal for personal use or
                          gifting
                          <br />
                          Nationwide shipping available | Bulk and corporate
                          orders welcome
                          <br />
                          <span role='img' aria-label='phone'>
                            📞
                          </span>
                          Contact: Tesla Bird Experience, India | +91 97406
                          33719
                        </div>
                      </div>
                    )}

                    {showMore && (
                      <>
                     
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                          <span style={learnMoreStyle} onClick={handleToggle}>
                            Show Less ▲
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div> */}

                <div className='row g-3'>
                  <div className='col-12'>
                    <div className='d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3'>
                      <div className='flex-grow-1'>
                        <h2 style={titleStyle}>
                          Tesla Bird Mental Wellness Card Kit + Vasudhaiva
                          Kutumbakam Program
                        </h2>
                        <p style={subtitleStyle}>
                          INR 209 monthly (INR 2499 Annual) | Empower Your Mind,
                          Daily
                        </p>
                        <p style={priceStyle}>
                          In today’s fast-paced world, mental wellness is
                          paramount. The Tesla Bird Mental Wellness Card Kit is
                          your daily companion, designed to enhance emotional
                          resilience, focus, and self-care.
                        </p>
                        <p style={priceStyle}>
                          Whether you’re a student, professional, parent, or
                          someone seeking balance, this kit offers practical
                          tools aligned with global mental health guidelines.
                        </p>
                      </div>

                      <div className='flex-shrink-0 align-self-center align-self-lg-start'>
                        <button
                          className='btn'
                          style={buttonStyle}
                          onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#3a5a8a'
                            e.currentTarget.style.transform = 'translateY(-2px)'
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = '#4a6fa5'
                            e.currentTarget.style.transform = 'translateY(0)'
                          }}
                          onClick={handlePayment}
                        >
                          Pay Now
                        </button>
                      </div>
                    </div>

                    <div className='text-center mt-3'>
                      {!showMore && (
                        <span style={learnMoreStyle} onClick={handleToggle}>
                          Learn More ▼
                        </span>
                      )}
                    </div>
                    {/* Extended Section */}
                    {showMore && (
                      <div className='mt-4'>
                        <h2
                          style={{
                            color: '#2c4f6e',
                            fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
                            fontWeight: '600',
                            marginTop: '25px',
                            marginBottom: '15px',
                          }}
                        >
                          What's Inside the Kit:
                        </h2>

                        <div
                          style={{
                            color: '#2c4f6e',
                            fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                            lineHeight: '1.5',
                          }}
                        >
                          <p className='mb-2'>
                            <strong>
                              1. 100 Mental Wellness Overview Cards:
                            </strong>
                          </p>
                          <p className='ms-3 mb-3'>
                            Gain clear insights into over 100 mental health
                            conditions, including anxiety, depression, ADHD, and
                            more. Based on WHO Mental Health Framework and
                            NIMHANS India guidelines.
                          </p>

                          <p className='mb-2'>
                            <strong>2. Brain Teasers Cards:</strong>
                          </p>
                          <p className='ms-3 mb-3'>
                            Engage with puzzles and logic tasks to boost memory
                            and cognitive flexibility.
                          </p>

                          <p className='mb-2'>
                            <strong>3. Meditation & Breathing Cards:</strong>
                          </p>
                          <p className='ms-3 mb-3'>
                            Access guided techniques like box breathing and
                            grounding meditations for instant stress relief.
                          </p>

                          <p className='mb-2'>
                            <strong>4. Mind Cognitive Cards:</strong>
                          </p>
                          <p className='ms-3 mb-3'>
                            Develop emotional intelligence and resilience
                            through daily prompts.
                          </p>

                          <p className='mb-2'>
                            <strong>
                              5. Mental Wellness Planner & Journals:
                            </strong>
                          </p>
                          <p className='ms-3 mb-3'>
                            Track moods, habits, and reflections with structured
                            weekly planners.
                          </p>

                          <p className='mb-2'>
                            <strong>6. Gratification Cards:</strong>
                          </p>
                          <p className='ms-3 mb-3'>
                            Foster joy and connection with daily gratitude
                            exercises.
                          </p>
                        </div>

                        <div className='row mt-4 g-4'>
                          <div className='col-12 col-md-6'>
                            <h2
                              style={{
                                color: '#2c4f6e',
                                fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
                                fontWeight: '600',
                                marginBottom: '15px',
                              }}
                            >
                              Who This is For:
                            </h2>
                            <ul
                              style={{
                                color: '#2c4f6e',
                                fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                                paddingLeft: '20px',
                              }}
                            >
                              <li className='mb-2'>
                                Students managing academic stress
                              </li>
                              <li className='mb-2'>
                                Professionals facing workplace challenges
                              </li>
                              <li className='mb-2'>
                                Mental health facilitators and therapists
                              </li>
                              <li className='mb-2'>
                                Families aiming for emotional well-being
                              </li>
                              <li className='mb-2'>
                                Anyone seeking daily mental clarity and balance
                              </li>
                            </ul>
                          </div>

                          <div className='col-12 col-md-6'>
                            <h2
                              style={{
                                color: '#2c4f6e',
                                fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
                                fontWeight: '600',
                                marginBottom: '15px',
                              }}
                            >
                              Why It Works:
                            </h2>
                            <ul
                              style={{
                                color: '#2c4f6e',
                                fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                                paddingLeft: '20px',
                              }}
                            >
                              <li className='mb-2'>
                                Rooted in cognitive science and behavioral
                                psychology
                              </li>
                              <li className='mb-2'>
                                Aligns with NIMHANS and WHO mental well-being
                                practices
                              </li>
                              <li className='mb-2'>
                                Portable, non-digital, and user-friendly
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className='mt-4'>
                          <h2
                            style={{
                              color: '#2c4f6e',
                              fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
                              fontWeight: '600',
                              display: 'flex',
                              alignItems: 'center',
                              marginBottom: '15px',
                            }}
                          >
                            <span className='me-2'>📞</span> Mental Health
                            Support Resources:
                          </h2>
                          <p
                            style={{
                              color: '#2c4f6e',
                              fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                              marginBottom: '10px',
                            }}
                          >
                            If you or someone you know needs professional mental
                            health support:
                          </p>
                          <p
                            style={{
                              color: '#2c4f6e',
                              fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                              marginBottom: '5px',
                              fontWeight: '500',
                            }}
                          >
                            TELE-MANAS India Toll-Free 24/7 Helpline: 14416 or
                            1-800-891-4416
                          </p>
                          <p
                            style={{
                              color: '#2c4f6e',
                              fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                              marginBottom: '20px',
                            }}
                          >
                            Provides free, round-the-clock mental health support
                            in 20+ languages across India.
                          </p>
                        </div>

                        <div className='mt-3'>
                          <h2
                            style={{
                              color: '#2c4f6e',
                              fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
                              fontWeight: '600',
                              marginBottom: '15px',
                            }}
                          >
                            Enhance Your Life With:
                          </h2>
                          <ul
                            style={{
                              color: '#2c4f6e',
                              fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                              paddingLeft: '20px',
                            }}
                          >
                            <li className='mb-2'>Improved focus</li>
                            <li className='mb-2'>Emotional balance</li>
                            <li className='mb-2'>Daily self-care routines</li>
                            <li className='mb-2'>Increased self-awareness</li>
                            <li className='mb-2'>Cultivated Gratitude</li>
                          </ul>
                        </div>
                        <div className='mt-4' style={offerBoxStyle}>
                          <strong>Launch Offer: ₹2499/- Only</strong>
                          <br />
                          Eco-friendly packaging, ideal for personal use or
                          gifting
                          <br />
                          Nationwide shipping available | Bulk and corporate
                          orders welcome
                          <br />
                          <span role='img' aria-label='phone'>
                            📞
                          </span>
                          Contact: Tesla Bird Experience, India | +91 97406
                          33719
                        </div>
                      </div>
                    )}

                    {showMore && (
                      <>
                        <div className='text-center mt-3'>
                          <span style={learnMoreStyle} onClick={handleToggle}>
                            Show Less ▲
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vasudhaiva Kutumbakam Plan */}
          <div className='row mb-4'>
            <div className='col-12'>
              <div className='card' style={planCardStyle}>
                <div className='row align-items-center'>
                  <div className='col-lg-8 col-md-7 col-12'>
                    <h2 style={titleStyle}>Vasudhaiva Kutumbakam</h2>
                    <p style={subtitleStyle}>
                      in Sanskrit "World is one Family"
                    </p>
                    <p style={priceStyle}>INR 51 monthly (INR 612 Annual)</p>

                    <ul style={featureListStyle}>
                      {[
                        'Wellness Assessments',
                        'Podcasts from Experts',
                        'Readable content from Experts',
                        '5 Live Webinars in a Year',
                        '24/7 AI Therapist "Aarava" – Mental health support anytime, anywhere* (Limited option)',
                      ].map((item, i) => (
                        <li key={i} style={featureItemStyle}>
                          <span
                            style={{
                              position: 'absolute',
                              left: '0',
                              color: '#48bb78',
                            }}
                          >
                            -
                          </span>
                          {item}
                        </li>
                      ))}
                    </ul>

                    <p
                      style={{
                        color: '#4a6fa5',
                        fontSize: '0.9rem',
                        marginTop: '15px',
                        fontWeight: '500',
                      }}
                    >
                      Add INR 1500 → Annual AI Tool Access + Prime Access
                    </p>
                  </div>

                  <div className='col-lg-4 col-md-5 col-12 text-center position-relative'>
                    <button
                      style={buttonStyle}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#3a5a8a'
                        e.currentTarget.style.transform = 'translateY(-2px)'
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#4a6fa5'
                        e.currentTarget.style.transform = 'translateY(0)'
                      }}
                      onClick={handleEnquiry}
                    >
                      Enquire now
                    </button>

                    <img
                      src={Family}
                      alt='family-drawing'
                      className='img-fluid'
                      style={{
                        zIndex: 2,
                        maxWidth: '80%',
                        height: 'auto',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sthiramana Plan */}
          <div className='row'>
            <div className='col-12'>
              <div className='card' style={planCardStyle}>
                <div className='row align-items-center'>
                  <div className='col-lg-8 col-md-7 col-12'>
                    <h2 style={titleStyle}>Sthiramana</h2>
                    <p style={subtitleStyle}>
                      in Sanskrit "steady mind" or "stable mind", emphasizing
                      mental calmness and focus
                    </p>
                    <p style={priceStyle}>
                      Institution Users 501 Monthly (INR 6012 Annual)
                    </p>

                    <ul style={featureListStyle}>
                      {[
                        '32 Face to Face sessions from experts in a year (Institutions only)',
                        '24/7 AI Therapist "Aarava" – Mental health support anytime, anywhere',
                        'Comprehensive Health Checks – Prioritize your well-being with expert evaluations',
                        'Wellness Assessments',
                        'Readable content from Experts',
                        '5 Live Webinars in a Year',
                        'Experts – Mental & Physical wellness Podcast',
                        'Prime Access included',
                      ].map((item, i) => (
                        <li key={i} style={featureItemStyle}>
                          <span
                            style={{
                              position: 'absolute',
                              left: '0',
                              color: '#48bb78',
                            }}
                          >
                            -
                          </span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className='col-lg-4 col-md-5 col-12 text-center position-relative'>
                    <button
                      style={buttonStyle}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#3a5a8a'
                        e.currentTarget.style.transform = 'translateY(-2px)'
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#4a6fa5'
                        e.currentTarget.style.transform = 'translateY(0)'
                      }}
                      onClick={handleEnquiry}
                    >
                      Enquire now
                    </button>

                    <img
                      src={Brain}
                      alt='brain'
                      className='img-fluid'
                      style={{
                        zIndex: 2,
                        maxWidth: '120%',
                        height: 'auto',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='container'>
            {/* <p
              className='mt-3'
              style={{
                color: '#666666',
                fontFamily: 'Inter',
                fontWeight: '500',
                fontSize: '16px',
              }}
            >
              Welcome to Tesla Bird, an exclusive membership-only platform
              dedicated to enhancing mental and physical wellness for students,
              professionals, and individuals of all age groups. In today’s
              fast-paced world, everyday challenges can impact decision-making,
              productivity, and overall well-being. Tesla Bird is designed to
              support, guide, and empower you with resources that help you
              navigate life’s complexities with clarity and confidence.
            </p> */}

            <h2
              className='mt-5'
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                color: isHovered ? ' #223D6F' : '#666666',
                fontFamily: 'Inter',
                fontWeight: 600,
                fontSize: '32px',
                transition: 'color 0.2s ease',
                cursor: 'pointer',
              }}
            >
              Become a Tesla Bird Member Now!
            </h2>

            <p
              className='mt-4'
              style={{
                color: '#666666',
                fontFamily: 'Inter',
                fontWeight: '500',
                fontSize: '16px',
              }}
            >
              Welcome to Tesla Bird, an exclusive membership-only platform
              dedicated to enhancing mental and physical wellness for students,
              professionals, and individuals of all age groups. In today’s
              fast-paced world, everyday challenges can impact decision-making,
              productivity, and overall well-being. Tesla Bird is designed to
              support, guide, and empower you with resources that help you
              navigate life’s complexities with clarity and confidence.
            </p>

            <h2
              className='mt-5'
              style={{
                color: '#2D5272',
                fontFamily: 'Inter',
                fontWeight: '600',
                fontSize: '32px',
              }}
            >
              About prime access:
            </h2>

            <ul style={featureListStyle}>
              {[
                '“Next Move” Forbes top 100 billionaire’s business strategy research paper access',
                'AI Digital Global Museum Access – Explore innovation, art, and knowledge.',
                'Podcasts from experts - Legal & Civil Rights Assistance – Navigate legal challenges with ease.',
                'Podcasts on Financial Literacy',
                ' Access to 250 + Monuments across India through AR / VR',
                ' Access to Research, Scientific Innovations, Events from Top Universities in India & Globally',
                'Language Training',
                ' Podcast on UK, US, Australia High Commission sessions for Visa & Global Opportunities',
                'Podcasts on Government, Private & Achievers from various fields special sessions on various topics and current with most relevant topics',
              ].map((item, i) => (
                <li key={i} style={featureItemStyle}>
                  <span
                    style={{
                      position: 'absolute',
                      left: '0',
                      color: '#48bb78',
                    }}
                  >
                    -
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <h2
              className='text-center mt-5 mb-5'
              style={{
                color: '#2D5272',
                fontFamily: 'Inter',
                fontWeight: '600',
                fontSize: '32px',
              }}
            >
              Why Join the Tesla Bird Community?
            </h2>

            <p
              className='mt-4'
              style={{
                fontFamily: 'Inter',
                fontWeight: '500',
                fontSize: '16px',
                color: '#666666',
              }}
            >
              As a Tesla Bird member, you gain access to a holistic ecosystem
              that nurtures your mind and body while fostering personal and
              professional growth. Our platform offers:
            </p>
            <p
              className='mt-4'
              style={{
                fontFamily: 'Inter',
                fontWeight: '500',
                fontSize: '16px',
                color: '#666666',
              }}
            >
              Expert-Driven Content – Stay informed with in-depth articles,
              insights, and research on mental and physical wellness.
            </p>
            <p
              className='mt-4'
              style={{
                fontFamily: 'Inter',
                fontWeight: '500',
                fontSize: '16px',
                color: '#666666',
              }}
            >
              Connect with Professionals – Engage with leading experts and
              mentors who provide guidance on wellness, career, and life
              management.
            </p>
            <h2 style={{ color: '#666666' }}> Exclusive Member Benefits:</h2>

            <ul style={featureStyle}>
              {[
                ' Muscle Movement Physical & Mental Wellness Training – South India’s first school of sports & fitness science 32 Hours offline training with Globally recognized certification Affiliated by : NSDC (National Skill Development Corporation) Skill India International Accreditation Organization',
                '24/7 AI Therapist “Aarava” – Mental health support anytime, anywhere. (Aarava in Sanskrit means “calm, peaceful and emotional grounding”) ',
                'Experts – Mental & Physical wellness & Podcast',
                'Wellness Assessments',
                'Comprehensive Health Checks – Prioritize your well-being with expert evaluations.',
                'Access Nutrition & Wellness Products ',
                'AI Global Museum Access – Explore innovation, art, and knowledge. ',
                'Access to 250 + Monuments across India through AR / VR ',
                'Access to Research, Scientific Innovations, Events from Top Universities in India & Globally',
                '“Next Move” Forbes top 100 billionaire’s business strategy research paper access',
              ].map((item, i) => (
                <li key={i} style={featureItemStyle}>
                  <span
                    style={{
                      position: 'absolute',
                      left: '0',
                      color: '#48bb78',
                    }}
                  ></span>
                  {item}
                </li>
              ))}
            </ul>

            <h2 className='text-center mt-4 mb-4' style={{ color: '#2D5272' }}>
              A Community That Cares
            </h2>

            <p
              className='mb-5'
              style={{
                color: '#666666',
                fontFamily: 'Inter',
                fontWeight: '500',
                fontSize: '16px',
              }}
            >
              Tesla Bird isn’t just a platform—it’s a movement towards building
              a healthier, smarter, and more sustainable society. By addressing
              human values and behaviors, we aim to create solid, resilient
              communities where well-being and success go hand in hand.Join us
              today and take the first step towards a balanced, fulfilling, and
              empowered life.
            </p>
          </div>
        </div>

        {/* Responsive styles */}
        <style jsx>{`
          @media (max-width: 768px) {
            .container-fluid {
              padding: 20px 15px !important;
            }

            h1 {
              font-size: 2rem !important;
              text-align: center;
              margin-bottom: 30px !important;
            }

            .card {
              padding: 20px !important;
            }
          }
        `}</style>

        <Footer />
      </div>
    </>
  )
}

export default Membership

// import { useState } from 'react'
// import Header from './Header'
// import Family from '../Assets/Assests/family-drawing.png'
// import Brain from '../Assets/Assests/Brain-image.png'
// import Footer from './Footer'
// import { useNavigate } from 'react-router-dom'

// const Membership = () => {
//   const [showMore, setShowMore] = useState(false)
//   const [isHovered, setIsHovered] = useState(false)
//   const navigate = useNavigate()

//   const handleToggle = () => {
//     setShowMore((prev) => !prev)
//   }

//   const handlePayment = () => {
//     navigate('/payment-form')
//   }

//   const handleEnquiry = () => {
//     navigate('/enquiry-form')
//   }

//   const planCardStyle = {
//     backgroundColor: '#e6f3ff',
//     borderRadius: '15px',
//     padding: '20px',
//     marginBottom: '30px',
//     border: 'none',
//     boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
//     position: 'relative',
//     overflow: 'hidden',
//   }

//   const titleStyle = {
//     color: '#2D5272',
//     fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//     fontWeight: '600',
//     marginBottom: '8px',
//     lineHeight: '1.3',
//     fontFamily: 'Inter',
//   }

//   const subtitleStyle = {
//     color: '#4a6fa5',
//     marginBottom: '20px',
//     lineHeight: '1.4',
//     fontFamily: 'Inter',
//     fontWeight: '400',
//     fontSize: 'clamp(1rem, 3vw, 1.5rem)',
//   }

//   const priceStyle = {
//     color: '#2c5282',
//     fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//     fontWeight: '600',
//     marginBottom: '20px',
//   }

//   const featureListStyle = {
//     listStyle: 'none',
//     padding: '0',
//     margin: '0',
//   }

//   const featureStyle = {
//     padding: '0',
//     margin: '0',
//   }

//   const featureItemStyle = {
//     color: '#4a5568',
//     fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//     marginBottom: '8px',
//     paddingLeft: '15px',
//     position: 'relative',
//     lineHeight: '1.4',
//   }

//   const buttonStyle = {
//     backgroundColor: '#4a6fa5',
//     color: 'white',
//     border: 'none',
//     borderRadius: '25px',
//     padding: '10px 25px',
//     fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     width: '100%',
//     maxWidth: '200px',
//   }

//   const illustrationStyle = {
//     position: 'absolute',
//     right: '20px',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     opacity: '0.3',
//     width: '120px',
//     height: '120px',
//   }

//   const learnMoreStyle = {
//     fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
//     color: '#2D5272',
//     cursor: 'pointer',
//     marginTop: '10px',
//     display: 'inline-block',
//   }

//   const offerBoxStyle = {
//     background: '#2E5272CF',
//     color: 'white',
//     padding: '15px',
//     width: '100%',
//     borderRadius: '5px',
//     marginTop: '20px',
//     lineHeight: '1.6',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'space-between',
//     fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
//   }

//   return (
//     <>
//       <Header />

//       <div className='min-vh-100'>
//         <header
//           id='home'
//           className='container-fluid text-white d-flex align-items-center justify-content-center px-3 py-4'
//           style={{
//             backgroundColor: '#2D5272',
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             minHeight: '300px',
//             position: 'relative',
//             top: '50px',
//           }}
//         >
//           <div
//             className='text-center px-2 py-3 w-100'
//             style={{
//               zIndex: 2,
//               borderRadius: '10px',
//             }}
//           >
//             <h1
//               className='mb-0'
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '600',
//                 fontSize: 'clamp(1.8rem, 6vw, 3.2rem)',
//                 color: '#fff',
//               }}
//             >
//               Tesla Bird Membership
//             </h1>
//           </div>
//         </header>

//         <div
//           className='container-fluid px-3 px-md-4'
//           style={{ marginTop: '80px' }}
//         >
//           {/* Header */}
//           <div className='row mb-4 mb-md-5'>
//             <div className='col-12'>
//               <h1
//                 className='text-center text-md-start'
//                 style={{
//                   color: '#2c5282',
//                   fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
//                   fontWeight: '600',
//                   marginBottom: '0',
//                 }}
//               >
//                 Choose a plan
//               </h1>
//             </div>
//           </div>

//           {/* Vasudhaiva Kutumbakam Plan */}
//           <div className='row mb-4'>
//             <div className='col-12'>
//               <div className='card border-0' style={planCardStyle}>
//                 <div className='row align-items-center g-3'>
//                   <div className='col-12 col-lg-8 order-2 order-lg-1'>
//                     <h2 style={titleStyle}>Vasudhaiva Kutumbakam</h2>
//                     <p style={subtitleStyle}>
//                       in Sanskrit "World is one Family"
//                     </p>
//                     <p style={priceStyle}>INR 51 monthly (INR 612 Annual)</p>

//                     <ul style={featureListStyle}>
//                       {[
//                         'Wellness Assessments',
//                         'Podcasts from Experts',
//                         'Readable content from Experts',
//                         '5 Live Webinars in a Year',
//                         '24/7 AI Therapist "Aarava" – Mental health support anytime, anywhere* (Limited option)',
//                       ].map((item, i) => (
//                         <li key={i} style={featureItemStyle}>
//                           <span
//                             style={{
//                               position: 'absolute',
//                               left: '0',
//                               color: '#48bb78',
//                             }}
//                           >
//                             -
//                           </span>
//                           {item}
//                         </li>
//                       ))}
//                     </ul>

//                     <p
//                       className='mt-3'
//                       style={{
//                         color: '#4a6fa5',
//                         fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
//                         fontWeight: '500',
//                       }}
//                     >
//                       Add INR 1500 → Annual AI Tool Access + Prime Access
//                     </p>
//                   </div>

//                   <div className='col-12 col-lg-4 text-center order-1 order-lg-2'>
//                     <div className='d-flex flex-column align-items-center gap-3'>
//                       <button
//                         className='btn mb-2 mb-md-3'
//                         style={buttonStyle}
//                         onMouseOver={(e) => {
//                           e.currentTarget.style.backgroundColor = '#3a5a8a'
//                           e.currentTarget.style.transform = 'translateY(-2px)'
//                         }}
//                         onMouseOut={(e) => {
//                           e.currentTarget.style.backgroundColor = '#4a6fa5'
//                           e.currentTarget.style.transform = 'translateY(0)'
//                         }}
//                         onClick={handleEnquiry}
//                       >
//                         Enquire now
//                       </button>

//                       <img
//                         src={Family || '/placeholder.svg'}
//                         alt='family-drawing'
//                         className='img-fluid'
//                         style={{
//                           zIndex: 2,
//                           maxWidth: '100%',
//                           height: 'auto',
//                           maxHeight: '200px',
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Sthiramana Plan */}
//           <div className='row mb-4'>
//             <div className='col-12'>
//               <div className='card border-0' style={planCardStyle}>
//                 <div className='row align-items-center g-3'>
//                   <div className='col-12 col-lg-8 order-2 order-lg-1'>
//                     <h2 style={titleStyle}>Sthiramana</h2>
//                     <p style={subtitleStyle}>
//                       in Sanskrit "steady mind" or "stable mind", emphasizing
//                       mental calmness and focus
//                     </p>
//                     <p style={priceStyle}>
//                       Institution Users 501 Monthly (INR 6012 Annual)
//                     </p>

//                     <ul style={featureListStyle}>
//                       {[
//                         '32 Face to Face sessions from experts in a year (Institutions only)',
//                         '24/7 AI Therapist "Aarava" – Mental health support anytime, anywhere',
//                         'Comprehensive Health Checks – Prioritize your well-being with expert evaluations',
//                         'Wellness Assessments',
//                         'Readable content from Experts',
//                         '5 Live Webinars in a Year',
//                         'Experts – Mental & Physical wellness Podcast',
//                         'Prime Access included',
//                       ].map((item, i) => (
//                         <li key={i} style={featureItemStyle}>
//                           <span
//                             style={{
//                               position: 'absolute',
//                               left: '0',
//                               color: '#48bb78',
//                             }}
//                           >
//                             -
//                           </span>
//                           {item}
//                         </li>
//                       ))}
//                     </ul>
//                   </div>

//                   <div className='col-12 col-lg-4 text-center order-1 order-lg-2'>
//                     <div className='d-flex flex-column align-items-center gap-3'>
//                       <button
//                         className='btn mb-2 mb-md-3'
//                         style={buttonStyle}
//                         onMouseOver={(e) => {
//                           e.currentTarget.style.backgroundColor = '#3a5a8a'
//                           e.currentTarget.style.transform = 'translateY(-2px)'
//                         }}
//                         onMouseOut={(e) => {
//                           e.currentTarget.style.backgroundColor = '#4a6fa5'
//                           e.currentTarget.style.transform = 'translateY(0)'
//                         }}
//                         onClick={handleEnquiry}
//                       >
//                         Enquire now
//                       </button>

//                       <img
//                         src={Brain || '/placeholder.svg'}
//                         alt='brain'
//                         className='img-fluid'
//                         style={{
//                           zIndex: 2,
//                           maxWidth: '100%',
//                           height: 'auto',
//                           maxHeight: '200px',
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Mental Wellness Card Kit */}
//           <div className='row mb-4'>
//             <div className='col-12'>
//               <div className='card border-0' style={planCardStyle}>
//                 <div className='row g-3'>
//                   <div className='col-12'>
//                     <div className='d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3'>
//                       <div className='flex-grow-1'>
//                         <h2 style={titleStyle}>
//                           Tesla Bird Mental Wellness Card Kit
//                         </h2>
//                         <p style={subtitleStyle}>
//                           Price: ₹2499/- | Empower Your Mind, Daily
//                         </p>
//                         <p style={priceStyle}>
//                           In today's fast-paced world, mental wellness is
//                           paramount. The Tesla Bird Mental Wellness Card Kit is
//                           your daily companion, designed to enhance emotional
//                           resilience, focus, and self-care.
//                         </p>
//                         <p style={priceStyle}>
//                           Whether you're a student, professional, parent, or
//                           someone seeking balance, this kit offers practical
//                           tools aligned with global mental health guidelines.
//                         </p>
//                       </div>

//                       <div className='flex-shrink-0 align-self-center align-self-lg-start'>
//                         <button
//                           className='btn'
//                           style={buttonStyle}
//                           onMouseOver={(e) => {
//                             e.currentTarget.style.backgroundColor = '#3a5a8a'
//                             e.currentTarget.style.transform = 'translateY(-2px)'
//                           }}
//                           onMouseOut={(e) => {
//                             e.currentTarget.style.backgroundColor = '#4a6fa5'
//                             e.currentTarget.style.transform = 'translateY(0)'
//                           }}
//                           onClick={handlePayment}
//                         >
//                           Pay Now
//                         </button>
//                       </div>
//                     </div>

//                     <div className='text-center mt-3'>
//                       {!showMore && (
//                         <span style={learnMoreStyle} onClick={handleToggle}>
//                           Learn More ▼
//                         </span>
//                       )}
//                     </div>

//                     {/* Extended Section */}
//                     {showMore && (
//                       <div className='mt-4'>
//                         <h2
//                           style={{
//                             color: '#2c4f6e',
//                             fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
//                             fontWeight: '600',
//                             marginTop: '25px',
//                             marginBottom: '15px',
//                           }}
//                         >
//                           What's Inside the Kit:
//                         </h2>

//                         <div
//                           style={{
//                             color: '#2c4f6e',
//                             fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//                             lineHeight: '1.5',
//                           }}
//                         >
//                           <p className='mb-2'>
//                             <strong>
//                               1. 100 Mental Wellness Overview Cards:
//                             </strong>
//                           </p>
//                           <p className='ms-3 mb-3'>
//                             Gain clear insights into over 100 mental health
//                             conditions, including anxiety, depression, ADHD, and
//                             more. Based on WHO Mental Health Framework and
//                             NIMHANS India guidelines.
//                           </p>

//                           <p className='mb-2'>
//                             <strong>2. Brain Teasers Cards:</strong>
//                           </p>
//                           <p className='ms-3 mb-3'>
//                             Engage with puzzles and logic tasks to boost memory
//                             and cognitive flexibility.
//                           </p>

//                           <p className='mb-2'>
//                             <strong>3. Meditation & Breathing Cards:</strong>
//                           </p>
//                           <p className='ms-3 mb-3'>
//                             Access guided techniques like box breathing and
//                             grounding meditations for instant stress relief.
//                           </p>

//                           <p className='mb-2'>
//                             <strong>4. Mind Cognitive Cards:</strong>
//                           </p>
//                           <p className='ms-3 mb-3'>
//                             Develop emotional intelligence and resilience
//                             through daily prompts.
//                           </p>

//                           <p className='mb-2'>
//                             <strong>
//                               5. Mental Wellness Planner & Journals:
//                             </strong>
//                           </p>
//                           <p className='ms-3 mb-3'>
//                             Track moods, habits, and reflections with structured
//                             weekly planners.
//                           </p>

//                           <p className='mb-2'>
//                             <strong>6. Gratification Cards:</strong>
//                           </p>
//                           <p className='ms-3 mb-3'>
//                             Foster joy and connection with daily gratitude
//                             exercises.
//                           </p>
//                         </div>

//                         <div className='row mt-4 g-4'>
//                           <div className='col-12 col-md-6'>
//                             <h2
//                               style={{
//                                 color: '#2c4f6e',
//                                 fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
//                                 fontWeight: '600',
//                                 marginBottom: '15px',
//                               }}
//                             >
//                               Who This is For:
//                             </h2>
//                             <ul
//                               style={{
//                                 color: '#2c4f6e',
//                                 fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//                                 paddingLeft: '20px',
//                               }}
//                             >
//                               <li className='mb-2'>
//                                 Students managing academic stress
//                               </li>
//                               <li className='mb-2'>
//                                 Professionals facing workplace challenges
//                               </li>
//                               <li className='mb-2'>
//                                 Mental health facilitators and therapists
//                               </li>
//                               <li className='mb-2'>
//                                 Families aiming for emotional well-being
//                               </li>
//                               <li className='mb-2'>
//                                 Anyone seeking daily mental clarity and balance
//                               </li>
//                             </ul>
//                           </div>

//                           <div className='col-12 col-md-6'>
//                             <h2
//                               style={{
//                                 color: '#2c4f6e',
//                                 fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
//                                 fontWeight: '600',
//                                 marginBottom: '15px',
//                               }}
//                             >
//                               Why It Works:
//                             </h2>
//                             <ul
//                               style={{
//                                 color: '#2c4f6e',
//                                 fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//                                 paddingLeft: '20px',
//                               }}
//                             >
//                               <li className='mb-2'>
//                                 Rooted in cognitive science and behavioral
//                                 psychology
//                               </li>
//                               <li className='mb-2'>
//                                 Aligns with NIMHANS and WHO mental well-being
//                                 practices
//                               </li>
//                               <li className='mb-2'>
//                                 Portable, non-digital, and user-friendly
//                               </li>
//                             </ul>
//                           </div>
//                         </div>

//                         <div className='mt-4'>
//                           <h2
//                             style={{
//                               color: '#2c4f6e',
//                               fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
//                               fontWeight: '600',
//                               display: 'flex',
//                               alignItems: 'center',
//                               marginBottom: '15px',
//                             }}
//                           >
//                             <span className='me-2'>📞</span>
//                             Mental Health Support Resources:
//                           </h2>
//                           <p
//                             style={{
//                               color: '#2c4f6e',
//                               fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//                               marginBottom: '10px',
//                             }}
//                           >
//                             If you or someone you know needs professional mental
//                             health support:
//                           </p>
//                           <p
//                             style={{
//                               color: '#2c4f6e',
//                               fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//                               marginBottom: '5px',
//                               fontWeight: '500',
//                             }}
//                           >
//                             TELE-MANAS India Toll-Free 24/7 Helpline: 14416 or
//                             1-800-891-4416
//                           </p>
//                           <p
//                             style={{
//                               color: '#2c4f6e',
//                               fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//                               marginBottom: '20px',
//                             }}
//                           >
//                             Provides free, round-the-clock mental health support
//                             in 20+ languages across India.
//                           </p>
//                         </div>

//                         <div className='mt-3'>
//                           <h2
//                             style={{
//                               color: '#2c4f6e',
//                               fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
//                               fontWeight: '600',
//                               marginBottom: '15px',
//                             }}
//                           >
//                             Enhance Your Life With:
//                           </h2>
//                           <ul
//                             style={{
//                               color: '#2c4f6e',
//                               fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
//                               paddingLeft: '20px',
//                             }}
//                           >
//                             <li className='mb-2'>Improved focus</li>
//                             <li className='mb-2'>Emotional balance</li>
//                             <li className='mb-2'>Daily self-care routines</li>
//                             <li className='mb-2'>Increased self-awareness</li>
//                             <li className='mb-2'>Cultivated Gratitude</li>
//                           </ul>
//                         </div>

//                         <div className='mt-4' style={offerBoxStyle}>
//                           <strong>Launch Offer: ₹2200/- Only</strong>
//                           <br />
//                           Eco-friendly packaging, ideal for personal use or
//                           gifting
//                           <br />
//                           Nationwide shipping available | Bulk and corporate
//                           orders welcome
//                           <br />
//                           <span role='img' aria-label='phone'>
//                             📞
//                           </span>
//                           Contact: Tesla Bird Experience, India | +91 97406
//                           33719
//                         </div>
//                       </div>
//                     )}

//                     {showMore && (
//                       <div className='text-center mt-3'>
//                         <span style={learnMoreStyle} onClick={handleToggle}>
//                           Show Less ▲
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Additional Content */}
//           <div className='row'>
//             <div className='col-12'>
//               <p
//                 className='mt-3'
//                 style={{
//                   color: '#666666',
//                   fontFamily: 'Inter',
//                   fontWeight: '500',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 Welcome to Tesla Bird, an exclusive membership-only platform
//                 dedicated to enhancing mental and physical wellness for
//                 students, professionals, and individuals of all age groups. In
//                 today's fast-paced world, everyday challenges can impact
//                 decision-making, productivity, and overall well-being. Tesla
//                 Bird is designed to support, guide, and empower you with
//                 resources that help you navigate life's complexities with
//                 clarity and confidence.
//               </p>

//               <h2
//                 className='mt-4 mt-md-5 text-center text-md-start'
//                 onMouseEnter={() => setIsHovered(true)}
//                 onMouseLeave={() => setIsHovered(false)}
//                 style={{
//                   color: isHovered ? ' #223D6F' : '#666666',
//                   fontFamily: 'Inter',
//                   fontWeight: 600,
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                   transition: 'color 0.2s ease',
//                   cursor: 'pointer',
//                 }}
//               >
//                 Become a Tesla Bird Member Now!
//               </h2>

//               <p
//                 className='mt-3 mt-md-4'
//                 style={{
//                   color: '#666666',
//                   fontFamily: 'Inter',
//                   fontWeight: '500',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 Welcome to Tesla Bird, an exclusive membership-only platform
//                 dedicated to enhancing mental and physical wellness for
//                 students, professionals, and individuals of all age groups. In
//                 today's fast-paced world, everyday challenges can impact
//                 decision-making, productivity, and overall well-being. Tesla
//                 Bird is designed to support, guide, and empower you with
//                 resources that help you navigate life's complexities with
//                 clarity and confidence.
//               </p>

//               <h2
//                 className='mt-4 mt-md-5 text-center text-md-start'
//                 style={{
//                   color: '#2D5272',
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                 }}
//               >
//                 About prime access:
//               </h2>

//               <ul style={featureListStyle} className='mt-3'>
//                 {[
//                   '"Next Move" Forbes top 100 billionaire\'s business strategy research paper access',
//                   'AI Digital Global Museum Access – Explore innovation, art, and knowledge.',
//                   'Podcasts from experts - Legal & Civil Rights Assistance – Navigate legal challenges with ease.',
//                   'Podcasts on Financial Literacy',
//                   ' Access to 250 + Monuments across India through AR / VR',
//                   ' Access to Research, Scientific Innovations, Events from Top Universities in India & Globally',
//                   'Language Training',
//                   ' Podcast on UK, US, Australia High Commission sessions for Visa & Global Opportunities',
//                   'Podcasts on Government, Private & Achievers from various fields special sessions on various topics and current with most relevant topics',
//                 ].map((item, i) => (
//                   <li key={i} style={featureItemStyle}>
//                     <span
//                       style={{
//                         position: 'absolute',
//                         left: '0',
//                         color: '#48bb78',
//                       }}
//                     >
//                       -
//                     </span>
//                     {item}
//                   </li>
//                 ))}
//               </ul>

//               <h2
//                 className='text-center mt-4 mt-md-5 mb-3 mb-md-5'
//                 style={{
//                   color: '#2D5272',
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                 }}
//               >
//                 Why Join the Tesla Bird Community?
//               </h2>

//               <p
//                 className='mt-3 mt-md-4'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '500',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   color: '#666666',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 As a Tesla Bird member, you gain access to a holistic ecosystem
//                 that nurtures your mind and body while fostering personal and
//                 professional growth. Our platform offers:
//               </p>

//               <p
//                 className='mt-3 mt-md-4'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '500',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   color: '#666666',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 Expert-Driven Content – Stay informed with in-depth articles,
//                 insights, and research on mental and physical wellness.
//               </p>

//               <p
//                 className='mt-3 mt-md-4'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '500',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   color: '#666666',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 Connect with Professionals – Engage with leading experts and
//                 mentors who provide guidance on wellness, career, and life
//                 management.
//               </p>

//               <h2
//                 className='mt-4 text-center text-md-start'
//                 style={{
//                   color: '#666666',
//                   fontSize: 'clamp(1.3rem, 3.5vw, 1.8rem)',
//                   fontWeight: '600',
//                 }}
//               >
//                 Exclusive Member Benefits:
//               </h2>

//               <ul style={featureStyle} className='mt-3'>
//                 {[
//                   " Muscle Movement Physical & Mental Wellness Training – South India's first school of sports & fitness science 32 Hours offline training with Globally recognized certification Affiliated by : NSDC (National Skill Development Corporation) Skill India International Accreditation Organization",
//                   '24/7 AI Therapist "Aarava" – Mental health support anytime, anywhere. (Aarava in Sanskrit means "calm, peaceful and emotional grounding") ',
//                   'Experts – Mental & Physical wellness & Podcast',
//                   'Wellness Assessments',
//                   'Comprehensive Health Checks – Prioritize your well-being with expert evaluations.',
//                   'Access Nutrition & Wellness Products ',
//                   'AI Global Museum Access – Explore innovation, art, and knowledge. ',
//                   'Access to 250 + Monuments across India through AR / VR ',
//                   'Access to Research, Scientific Innovations, Events from Top Universities in India & Globally',
//                   '"Next Move" Forbes top 100 billionaire\'s business strategy research paper access',
//                 ].map((item, i) => (
//                   <li key={i} style={featureItemStyle}>
//                     <span
//                       style={{
//                         position: 'absolute',
//                         left: '0',
//                         color: '#48bb78',
//                       }}
//                     ></span>
//                     {item}
//                   </li>
//                 ))}
//               </ul>

//               <h2
//                 className='text-center mt-4 mb-3 mb-md-4'
//                 style={{
//                   color: '#2D5272',
//                   fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                   fontWeight: '600',
//                 }}
//               >
//                 A Community That Cares
//               </h2>

//               <p
//                 className='mb-4 mb-md-5'
//                 style={{
//                   color: '#666666',
//                   fontFamily: 'Inter',
//                   fontWeight: '500',
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   lineHeight: '1.6',
//                 }}
//               >
//                 Tesla Bird isn't just a platform—it's a movement towards
//                 building a healthier, smarter, and more sustainable society. By
//                 addressing human values and behaviors, we aim to create solid,
//                 resilient communities where well-being and success go hand in
//                 hand. Join us today and take the first step towards a balanced,
//                 fulfilling, and empowered life.
//               </p>
//             </div>
//           </div>
//         </div>

//         <Footer />
//       </div>
//     </>
//   )
// }

// export default Membership
